import React from 'react'
import styled from 'styled-components'

const StyledIntroSection = styled.div`
  max-width: 500px;
  text-align: center;
  margin: 2rem auto;
`

const IntroSection = ({ children }) => (
  <StyledIntroSection>{children}</StyledIntroSection>
)

export default IntroSection
